interface Props {
  features: string[];
}

export const isLandingPageFeatureEnabled = ({
  features,
  pref,
}: {
  features: string[];
  pref: string;
}) => {
  if (!pref) {
    return false;
  }
  return Array.isArray(features) && features.includes(pref);
};

/**
 * Added by the API.  The page content includes at least 1 Wistia video.
 * This allows the page to include the "base wistia script" only once.
 * There's no need to iterate thru all the sections to determine if there's a video.
 */
export const isWistiaVideoIncluded = ({ features }: Props) => {
  return isLandingPageFeatureEnabled({ features, pref: 'WistiaVideoIncluded' });
};

/**
 * The landing-page should display the "table of contents".
 * Otherwise, it should be hidden.
 * Always include anchor links.
 */
export const isTableOfContentsEnabled = ({ features }: Props) => {
  return isLandingPageFeatureEnabled({ features, pref: 'TableOfContents' });
};

/**
 * The hero's title and description should be hidden.
 */
export const isHeroTextHidden = ({ features }: Props) => {
  return isLandingPageFeatureEnabled({ features, pref: 'HeroTextHidden' });
};

/**
 * For any video cards on this landing-page, the video should span the margins.
 * Any title and description should appear below the video.
 */
export const isVideoCardWidescreen = ({ features }: Props) => {
  return isLandingPageFeatureEnabled({ features, pref: 'VideoCardWidescreen' });
};

/**
 * The hero's video should consume more vertical space.
 */
export const isHeroTheaterMode = ({ features }: Props) => {
  return isLandingPageFeatureEnabled({ features, pref: 'HeroTheaterMode' });
};

/**
 * Adds a wave transition below the hero.
 */
export const isHeroWaveOutline = ({ features }: Props) => {
  return isLandingPageFeatureEnabled({ features, pref: 'HeroWaveOutline' });
};
